import { CSSObject } from '@chakra-ui/react';
import { TLinkContainer } from './NextToJumpItem.styles';

export const LinkContainer = ({ isLast }: TLinkContainer) => ({
  borderBottom: !isLast && '1px dashed',
  borderBottomColor: 'blackAlpha.300',
  borderRadius: 'unset',
  px: '0',
  py: '2',
  mb: 'unset',
  mx: '2',
  w: 'auto',
  mt: '-0.5',
  bg: 'transparent',
  _hover: {
    bg: 'blackAlpha.100',
  },
});

export const BoxNextToJumpContainer: CSSObject = {
  bg: 'white',
  mx: '0',
  borderRadius: 'base',
  mb: '4',
};

export const Icon: CSSObject = {
  color: 'beta.400',
  bgGradient: 'linear(to-b, alpha.500, alpha.700)',
  borderRadius: 'base',
  filter: 'drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.25))',
};

export const TextRace: CSSObject = {
  color: 'gray.700',
  fontFamily: 'Roboto',
  fontSize: 'xs',
  fontStyle: 'normal',
  lineHeight: 'normal',
  fontWeight: 'medium',
};

export const TextNumber: CSSObject = {
  bg: 'alpha.200',
  color: 'alpha.600',
  h: '4',
  py: '0',
  pt: '0.5',
  borderRadius: 'base',
};

export const BoxHeading: CSSObject = {
  display: 'none',
};

export const FlexWrapper: CSSObject = {
  '.state-inprogress': {
    color: ['white', 'beta.900'],
  },
  '.chakra-badge': {
    borderRadius: 'sm',
    h: '4',
    minH: '4',
    py: '0',
    mr: '0.5',
    color: 'alpha.800',
  },
};
